import type { PresetPercentage } from 'uniswap/src/components/CurrencyInputPanel/AmountInputPresets/types'

export const PRESET_MAX = 100
export const PRESET_PERCENTAGES: PresetPercentage[] = [25, 50, 75, 100]
